"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFunction = void 0;
const excelFormulaParser = __importStar(require("excel-formula-parser"));
const context_1 = require("./context");
const visitor_1 = require("./visitor");
// This method wraps all use of the excel-formula-parser library
// It is not typed well, so it is preferable to avoid calling it directly outside of this file
// TODO: replace it by implementing the syntax tree processing logic (shunting yard algorithm) within this package
const buildFunction = ({ formula, }) => {
    // ----- Create abstract syntax tree -----
    const tree = excelFormulaParser.parse(formula);
    // ----- Create shared context for node visitors -----
    const buildContext = (0, context_1.createBuildContext)(formula);
    const visitorContext = (0, context_1.createVisitorContext)();
    // ----- Generate visitor functions used for excel-formula-parser -----
    const visitorFunctions = (0, visitor_1.getVisitorFunctions)({
        buildContext,
        visitorContext,
    });
    // ----- Visit all nodes using generated node visitor functions -----
    excelFormulaParser.visit(tree, visitorFunctions);
    // ----- Retrieve final function evaluator and required variables -----
    const formulaFunction = buildContext.getFormulaFunction();
    const rangeVariables = buildContext.rangeVariables.getAll();
    const rowVariables = buildContext.rowVariables.getAll();
    // ----- Set up result cache (usage determined by row variables) -----
    const resultCache = {
        enabled: rowVariables.length === 0,
        result: null,
    };
    return {
        buildHistory: visitorContext.history,
        rangeVariables,
        rowVariables,
        evaluate: (input) => {
            // Check for formula cache
            if (!resultCache.enabled) {
                return formulaFunction(input);
            }
            // If it is enabled, check if the result has not been saved
            if (resultCache.result === null) {
                // Update cache if not available
                resultCache.result = formulaFunction(input);
            }
            return resultCache.result;
        },
    };
};
exports.buildFunction = buildFunction;
//# sourceMappingURL=index.js.map